import Webservices from "@/Webservices";
import FileSaver from "file-saver";

const Json2csvParser = require("json2csv").Parser;
const ws = new Webservices();

export function dateParser(date) {
  if (date != undefined){
    return date.toLocaleString("pt-BR", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      timeZone: "UTC"
    });
  }
}

export async function getPeople(userID, start_date, end_date) {
  var pessoas = [];

  await ws.getPersons(userID, start_date, end_date).then(({ data }) => {
    var users = [];

    data.forEach(person => {
      if (!!person.userAuth && !users.includes(person.userAuth.mac)) {
        users.push(person.userAuth.mac);
        pessoas.push(person.userAuth);
      }
    });
  });

  return pessoas;
}

export async function getClientFields(userID) {
  var fields = [];

  await ws.getClientFields(userID).then(({ data }) => {
    fields = data.fields.filter(
      field => field.type != "label" && field.is_active
    );

    fields.push({ type: "string", name: "mac", label: "MAC" });

    var cpfFieldIndex = fields.findIndex(el => el.name === "cpf");

    if (cpfFieldIndex >= 0) {
      fields.splice(cpfFieldIndex, 1);
    }
  });

  return fields;
}

function downloadSheet(data, filename, opts) {
  const json2csvParser = new Json2csvParser(opts);
  const csv = json2csvParser.parse(data);

  var blob = new Blob([csv], {
    type: "text/csv"
  });

  FileSaver.saveAs(blob, filename);
}

export async function downloadUsers(userID, start_date, end_date, fields) {
  await ws.getPersons(userID, start_date, end_date).then(result => {
    var data = [];
    var macs = [];

    result.data.forEach(person => {
      if (person.userAuth) {
        if (!macs.includes(person.userAuth.mac)) {
          macs.push(person.userAuth.mac);

          if (person.userAuth.hasOwnProperty("birth_date")) {
            try {
              if (isNaN(new Date(person.userAuth.birth_date).getTime())) {
                person.userAuth.birth_date = person.userAuth.birth_date
                  .split("/")
                  .reverse()
                  .join("/");
              }

              person.userAuth.birth_date = new Date(
                person.userAuth.birth_date
              ).toLocaleDateString("pt-BR");
            } catch (exc) {
              person.userAuth.birth_date = "Invalid Date";
            }
          }

          data.push(person.userAuth);
        }
      }
    });

    var opts = { fields };

    downloadSheet(data, "usuarios.csv", opts);
  });
}

export async function downloadConnections(userID, start_date, end_date) {
  await ws.getConnections(userID, start_date, end_date).then(({ data }) => {
    downloadSheet(data, "conexoes.csv");
  });
}

export function loadDefaultData() {
  return {
    dates: [],
    perPage: 10,
    downloadingUsers: false,
    isSearch: false,
    searchTerm: "",
    fields: [],
    virtual_page: 1,
    dateSDDirty: false,
    dateEDDirty: false,
    isLoading: false,
    pagination: {
      page: 1,
      rowsPerPage: 10,
      totalItems: 0
    },
    dialogImport: false,
    dialog: true,
    validateDataByAge: false,
    start_date: "",
    end_date: "",
    showFilter: true,
    isFiltering: true,
    dateSD: "",
    dateED: "",
    modalSD: false,
    modalED: false,
    pessoas: [],
    dialog: false,
    dialogDay: false,
    dialogConnected: false,
    dialogAge: false,
    dialogSex: false,
    start_date: "",
    end_date: "",
    dateSD: "",
    dateED: "",
    data: [],
    data_v2: [],
    data_news: [],
    idInterval: undefined,
    hasGender: false,
    hasBirth_date: false,
    debug_mode: 0,
    loadIterations: 0,
    dataByAgeArray: {},
    perPage: 20,
    dates: [],
    dialogList: false,
    dialogAlert: false
  };
}



// WEBPACK FOOTER //
// ./src/functions/pessoas.js